import Enum from "../../common/models/Enum";

class AnalysisNature extends Enum {
  static OIL = "oil";

  static values = [AnalysisNature.OIL];

  static readables = {
    [AnalysisNature.OIL]: "enum.analysis_nature.oil",
  };
}

export default AnalysisNature;
